import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ILocalAGGrid, {
  getDefaultColDef,
} from '../../grid/iLocalAGGrid';
import {
  createAccountResourceDatasource,
  syncGridPageSize,
} from './accountResourceGridUtils';

const LocationSortObj = {
  name: { tableName: 'boxes', sortColumn: 'name' },
  type: { tableName: 'box_type', sortColumn: 'type' },
  IsActive: { tableName: 'boxes', sortColumn: 'IsActive' },
  city: { tableName: 'addresses', sortColumn: 'city' },
};

class AccountLocationsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.filterObj = {
      searchtext: '',
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'created_on',
      accountId: props.accountId,
    };
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createAccountResourceDatasource({
      filterObj: this.filterObj,
      sortMap: LocationSortObj,
      endpoint: 'accounts/locations/by/account',
      getAccountId: () => this.props.accountId,
    });
    if (typeof params.api.setServerSideDatasource === 'function') {
      params.api.setServerSideDatasource(datasource);
    }
  };

  onPaginationChanged = (params) => {
    syncGridPageSize(params, this.filterObj);
  };

  formatActive = (value) => {
    const { t } = this.props;
    if (value === true || value === 'true' || value === 1 || value === '1') {
      return t('Common.Yes');
    }
    return t('Common.No');
  };

  render() {
    const { t } = this.props;
    return (
      <ILocalAGGrid
        columnDefs={[
          { field: 'name', headerName: t('Location.Name') },
          {
            field: 'type',
            headerName: t('Location.Details.BoxType'),
            valueGetter: (params) =>
              (params.data && params.data.type && params.data.type.name) || '',
          },
          {
            field: 'IsActive',
            headerName: t('Location.Details.LocationIsActiveToggle'),
            filter: false,
            valueGetter: (params) =>
              this.formatActive(params.data && params.data.IsActive),
          },
          {
            field: 'city',
            headerName: t('Location.Details.City'),
            valueGetter: (params) =>
              (params.data && params.data.address && params.data.address.city) ||
              '',
          },
        ]}
        defaultColDef={getDefaultColDef()}
        rowModelType='serverSide'
        cacheBlockSize={this.filterObj.pageSize || 10}
        paginationPageSize={this.filterObj.pageSize || 10}
        paginationPageSizeSelector={[10, 20, 25]}
        rowHeight={45}
        getRowId={(params) => params.data && params.data.id}
        onGridReady={this.onGridReady}
        onPaginationChanged={this.onPaginationChanged}
        overlayNoRowsMessage={t('Location.NoDataFound')}
      />
    );
  }
}

AccountLocationsDialog.propTypes = {
  accountId: PropTypes.string,
};

export default withTranslation()(AccountLocationsDialog);



// WEBPACK FOOTER //
// ./src/components/account-list/related/AccountLocationsDialog.js